import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import CancellationPolicy from '../../components/CancellationPolicies';

import s from './Policies.css';

const Policies = (props) => {
	const { policyType } = props;
	return (
		<div className={s.root}>
			<div className={s.container}>
				<CancellationPolicy policyType={policyType} />
			</div>
		</div>
	);
}

Policies.propTypes = {
	policyType: PropTypes.string.isRequired,
};

Policies.defaultProps = {
	policyType: 'Flexible'
};

export default withStyles(s)(Policies);